module.exports = __webpack_public_path__ + "static/media/edit-icon.6a21d77a.svg";